import { Component, OnInit, Output } from '@angular/core';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { Bulletin, JobHistory, Dashboard } from '../model/dashboard';
import { AppService } from '../services/app.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  BulletinItems?: Bulletin[];
  JobHisItems?: JobHistory[];
  controllerName = 'Dashboard';
  displayedColumns: string[] = ['Project', 'Region', 'StartDate', 'EndDate', 'Status'];
  showJob: boolean = false;

  constructor(private dataSer: DataService,private appService: AppService) { }

  ngOnInit() {
    setTimeout(() => this.appService.SetLoadingState(true), 0);
    this.Search();
  }

  Search() {
    console.log('[DashboardComponent][Search]');
    // request api - getdata
    this.dataSer.getData(this.controllerName, null,
      (data) => {
        this.BulletinItems = data.Bulletins;
        setTimeout(() => this.appService.SetLoadingState(false), 0);
      });
  }

  OpenBulletin($event, bulletinItem) {
    console.log(bulletinItem);
  }
}
